"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalButtonSuite = ModalButtonSuite;
exports.useModalClose = useModalClose;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var ModalCloseContext = (0, react_1.createContext)(function () { });
function CloseIcon() {
    return (react_1.default.createElement("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" },
        react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M6 18L18 6M6 6l12 12" })));
}
function Modal(_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, children = _a.children;
    var _b = (0, react_1.useState)(null), modalRoot = _b[0], setModalRoot = _b[1];
    (0, react_1.useEffect)(function () {
        var root = document.createElement("div");
        root.id = "modal-root";
        document.body.appendChild(root);
        setModalRoot(root);
        return function () {
            if (document.body.contains(root)) {
                document.body.removeChild(root);
            }
        };
    }, []);
    if (!isOpen || !modalRoot)
        return null;
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "modal-overlay" },
        react_1.default.createElement("div", { className: "modal-content-box" },
            react_1.default.createElement("div", { className: "modal-content" },
                react_1.default.createElement("h2", null, title),
                react_1.default.createElement("button", { onClick: onClose },
                    react_1.default.createElement(CloseIcon, null))),
            react_1.default.createElement("div", { className: "modal-body" },
                react_1.default.createElement(ModalCloseContext.Provider, { value: onClose }, children)))), modalRoot);
}
function ModalButtonSuite(_a) {
    var children = _a.children, title = _a.title, onOpen = _a.onOpen;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    (0, react_1.useEffect)(function () {
        var handleEsc = function (event) {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            window.addEventListener("keydown", handleEsc);
        }
        return function () {
            window.removeEventListener("keydown", handleEsc);
        };
    }, [isOpen]);
    var openModal = function () {
        setIsOpen(true);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    };
    var closeModal = function () {
        setIsOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "zmsk-button", onClick: openModal }, title),
        react_1.default.createElement(Modal, { isOpen: isOpen, onClose: closeModal, title: title }, children)));
}
function useModalClose() {
    return (0, react_1.useContext)(ModalCloseContext);
}
